import React, { Fragment } from 'react';
import { Field } from 'formik';
import {
  Body,
  Checkbox,
  DocNote,
  FovFieldError,
  FovOption,
  FovSelect,
  HorizontalSpacer,
  VerticalSpacer,
} from 'components';
import { MeshCheckbox, MeshControl, Slider } from './RPCFormStyles';

const ProxySection = ({
  form,
  proxyOptions,
  selectedProxyMesh,
  setSelectedProxyMesh,
  enableMeshSlider,
  setEnableMeshSlider,
}) => {
  return (
    <Fragment>
      <Body>
        Proxy
        <DocNote path={[ 'publishPanel', 'proxy' ]} top={-1} left={50} />
      </Body>
      <VerticalSpacer size={10} />

      <Field type='select' name='proxyName'>
        {data => (
          <FovSelect
            value={data.field.value}
            placeholder={data.field.value || 'Select a proxy'}
            onChange={(e, newVal) => {
              form.setFieldValue(data.field.name, newVal);
              setSelectedProxyMesh(newVal);
            }}
          >
            {proxyOptions.map((proxy, index) => (
              <FovOption key={index} value={proxy}>
                {proxy}
              </FovOption>
            ))}
          </FovSelect>
        )}
      </Field>

      <FovFieldError name='proxyName' />

      {selectedProxyMesh === 'simpleMesh' && (
        <MeshControl>
          <Slider
            defaultValue={0.5}
            disabled={!enableMeshSlider}
            onAfterChange={newVal => {
              form.setFieldValue('decimateAmount', newVal);
            }}
          />

          <MeshCheckbox htmlFor='meshCheckbox'>
            <Checkbox
              name='meshCheckbox'
              checked={enableMeshSlider}
              onChange={e => {
                const newVal = e.target.checked;
                setEnableMeshSlider(newVal);
              }}
            />
            <HorizontalSpacer size={10} />
            Mesh control
          </MeshCheckbox>

          <VerticalSpacer size={15} />
        </MeshControl>
      )}
    </Fragment>
  );
};

export default ProxySection;

